'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _withReduxForm = require('./../../libs/hocs/withReduxForm');

var _withReduxForm2 = _interopRequireDefault(_withReduxForm);

var _RenderIf = require('../RenderIf');

var _RenderIf2 = _interopRequireDefault(_RenderIf);

var _RequiredAsterisk = require('../RequiredAsterisk');

var _RequiredAsterisk2 = _interopRequireDefault(_RequiredAsterisk);

var _utils = require('./../../libs/utils');

var _context = require('./context');

require('./styles.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * A VisualPicker can be either radio buttons, checkboxes, or links that are visually enhanced.
 * @category Form
 */


var VisualPicker = function (_Component) {
  _inherits(VisualPicker, _Component);

  function VisualPicker(props) {
    _classCallCheck(this, VisualPicker);

    var _this = _possibleConstructorReturn(this, (VisualPicker.__proto__ || Object.getPrototypeOf(VisualPicker)).call(this, props));

    _this.errorId = (0, _utils.uniqueId)('error-message');
    _this.groupNameId = props.name || (0, _utils.uniqueId)('visual-picker');
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  _createClass(VisualPicker, [{
    key: 'getContainerClassNames',
    value: function getContainerClassNames() {
      var className = this.props.className;
      return (0, _classnames2["default"])('rainbow-visual-picker_container', className);
    }
  }, {
    key: 'getErrorMessageId',
    value: function getErrorMessageId() {
      var error = this.props.error;

      if (error) {
        return this.errorId;
      }

      return undefined;
    }
  }, {
    key: 'handleChange',
    value: function handleChange(optionName, optionChecked) {
      var _props = this.props,
          onChange = _props.onChange,
          multiple = _props.multiple,
          value = _props.value;
      var currentValue = optionName;

      if (multiple) {
        if (!Array.isArray(value)) {
          currentValue = optionChecked ? [optionName] : [];
        } else {
          currentValue = optionChecked ? [].concat(_toConsumableArray(value), [optionName]) : value.filter(function (item) {
            return item !== optionName;
          });
        }
      }

      onChange(currentValue);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          style = _props2.style,
          label = _props2.label,
          required = _props2.required,
          error = _props2.error,
          id = _props2.id,
          children = _props2.children,
          value = _props2.value,
          multiple = _props2.multiple;
      var context = {
        ariaDescribedby: this.getErrorMessageId(),
        groupName: this.groupNameId,
        privateOnChange: this.handleChange,
        value: value,
        multiple: multiple
      };
      return _react2["default"].createElement('fieldset', {
        id: id,
        className: this.getContainerClassNames(),
        style: style
      }, _react2["default"].createElement(_RenderIf2["default"], {
        isTrue: !!label
      }, _react2["default"].createElement('legend', {
        className: 'rainbow-visual-picker_label'
      }, _react2["default"].createElement(_RequiredAsterisk2["default"], {
        required: required
      }), label)), _react2["default"].createElement('div', {
        className: 'rainbow-visual-picker_options-container'
      }, _react2["default"].createElement(_context.Provider, {
        value: context
      }, children)), _react2["default"].createElement(_RenderIf2["default"], {
        isTrue: !!error
      }, _react2["default"].createElement('div', {
        id: this.getErrorMessageId(),
        className: 'rainbow-visual-picker_text-error'
      }, error)));
    }
  }]);

  return VisualPicker;
}(_react.Component);

VisualPicker.propTypes = {
  /** The name of VisualPicker. */
  name: _propTypes2["default"].string,

  /** The value of the element. */
  value: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].arrayOf(_propTypes2["default"].string)]),

  /** The id of the outer element. */
  id: _propTypes2["default"].string,

  /** The action triggered when a value attribute changes. */
  onChange: _propTypes2["default"].func,

  /** If is set to true the VisualPicker is required. This value defaults to false. */
  required: _propTypes2["default"].bool,

  /** The title at the top of the VisualPicker component. */
  label: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].node]),

  /** Specifies that an VisualPicker must be filled out before submitting the form. */
  error: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].node]),

  /** The class name of the root element. */
  className: _propTypes2["default"].string,

  /** It is an object with custom style applied to the root element. */
  style: _propTypes2["default"].object,

  /**
   * This prop that should not be visible in the documentation.
   * @ignore
   */
  children: _propTypes2["default"].oneOfType([_propTypes2["default"].arrayOf(_propTypes2["default"].node), _propTypes2["default"].object]),

  /** If true then a multiple selection is allowed */
  multiple: _propTypes2["default"].bool
};
VisualPicker.defaultProps = {
  name: null,
  value: undefined,
  id: undefined,
  onChange: function onChange() {},
  required: false,
  label: '',
  error: null,
  className: undefined,
  style: undefined,
  children: [],
  multiple: false
};
exports["default"] = (0, _withReduxForm2["default"])(VisualPicker);